import ConditionProperty from './ConditionProperty';
import ConditionVisibleControls from "./ConditionVisibleControls";
import { PresenceOperators, Operator } from "../Condition";

export default class PageElement extends ConditionProperty {
  static override readonly label: string = 'Page element';
  static override readonly formFields: ConditionVisibleControls  = { fieldName: false, fieldPath: false, fieldIndex: false };
  static override readonly type: number = 12;

  buildDescription(): string {
    return `Element [${this.condition.value}] ${this.getOperatorLabel()} on page`;
  }

  public override getOperators(): Array<Operator> {
    return PresenceOperators;
  }

  public override getValueLabel(): string {
    return 'Selector';
  }
}
